import React from "react";
import { BsyUtils } from "../../utils/Utils";
import "./index.css";
import { BsyWidget } from "../BsyWidget";
import { SearchComboPane } from "../BsyDataManage";
import BsyMsgBubble from "../BsyMsgBubble";
import BsySearchInput from "../BsySearchInput";
import BsyButton from "../BsyButton";
import BsyDataTable from "../BsyDataTable";
import BsyDataLoadFilterPane from "../BsyDataLoadFilterPane";

export class ShowDataPane extends BsyWidget {
  constructor(props) {
    super({
      minWidth: 100,
      baseCls: "bsy-show-data-list-pane",
      ...props,
    });

    this.state = {
      datalist: [],
      seachKey: "",
      allowAdd: props.allowAdd,
      loading: false,
      filterSticky: this.getFilterSticky() || false,
    };

    this.filter = [];
    // this.options.selectFields.map((it) => {
    //   return {
    //     ...this.defaultConfig2Value(it),
    //   };
    // });
    this.rel = props.selectRel;
    this.search = {
      fields: [],
      isSearchAllFields: true,
      keywords: [],
    };
  }

  _getComboCheckFilter = (t, e) => {
    let i = (e && e.items) || (e && e.value);
    let r = {
      type: t,
      hasEmpty: !!e?.hasEmpty,
      value: !BsyUtils.isObjectEmpty(i) ? BsyUtils.makeArray(i) : [],
      hasCurrentDept: !(!e || !e.hasCurrentDept),
      hasCurrentUser: !(!e || !e.hasCurrentUser),
      hasCurrentSubDept: !(!e || !e.hasCurrentSubDept),
      hasCurrentParDept: !(!e || !e.hasCurrentParDept),
    };
    if (e) {
      r.parentDepts = e.parentDepts ? BsyUtils.makeArray(e.parentDepts) : [];
    }
    switch (r.type) {
      case "flow_chargers":
      case "user":
      case "usergroup": {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        break;
      }
      case "deptgroup":
      case "dept": {
        delete r.hasCurrentUser;
        break;
      }
      default: {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        delete r.parentDepts;
        delete r.hasCurrentUser;
        break;
      }
    }
    return r;
  };
  _initFilter = () => {
    let e = this;
    this.filter = {};
    const fields = this.props.selectFields.map((it) => {
      return {
        ...it,
        mode: "edit",
        triggers: ["datatable"],
      };
    });
    BsyUtils.forEach(fields, function (t1, i) {
      if (!i || !i.widgetId) {
        return true;
      }

      let a = i.fields[0];
      let t = a.field;
      let n = {
        entryId: a.form,
        field: a.field,
        triggers: i.triggers,
        rely: i.rely,
      };

      if (a.subform) {
        n = {
          ...n,
          ...{
            subform: a.subform,
            subField: a.subField,
          },
        };
      }

      e.filter[t] = n;

      let valueMode = i.valueMode;
      let method = i.method;
      if (valueMode === "input") {
        if (!i.defaultConfig || !i.defaultConfig.value) {
          i.method = "empty";
        } else {
          if (i.defaultConfig.likeMatch === true) {
            i.method = "like";
          } else i.method = "eq";
        }
      }
      if (i.type === "number_filter" && !BsyUtils.isObjectEmpty(i.tick)) {
        let tickValue = i.tickValue;
        let a = i.defaultConfig;
        if (method === "range") {
          if (tickValue && a) {
            if (a.min) {
              switch (tickValue.min) {
                case "hour": {
                  a.min = a.min * 60 * 60;
                  break;
                }
                case "days": {
                  a.min = a.min * 60 * 60 * 24;
                  break;
                }
                case "minute":
                default: {
                  a.min = a.min * 60;
                  break;
                }
              }
            }
            if (a.max) {
              switch (tickValue.max) {
                case "hour": {
                  a.max = a.max * 60 * 60;
                  break;
                }
                case "days": {
                  a.max = a.max * 60 * 60 * 24;
                  break;
                }
                case "minute":
                default: {
                  a.max = a.max * 60;
                  break;
                }
              }
            }
          }
        } else {
          if (a && a.value) {
            switch (tickValue) {
              case "hour": {
                a.value = a.value * 60 * 60;
                break;
              }
              case "days": {
                a.value = a.value * 60 * 60 * 24;
                break;
              }
              case "minute":
              default: {
                a.value = a.value * 60;
                break;
              }
            }
          }
        }
      }
      e._updateFilter(t, i, i.defaultConfig);
    });
    console.log(this.filter);
    this.cond = Object.entries(this.filter).map((it) => {
      return it[1];
    });
  };
  _updateFilter = (t, e, i) => {
    let a = e.fields[0],
      n = {};
    this.filter[t] = this.filter[t] || {};
    n.method = e.method || BsyUtils.getDashDefaultFilterMethod(a && a.type);
    n.value = i;
    n.valueMode = e.valueMode;
    n.fields = e.fields;
    n.field = t;
    n.entryId = e.entryId || a.form;
    n.hasEmpty = n.method === "empty";
    if (a) {
      switch (a.type) {
        case "text":
        case "radiogroup":
        case "combo":
        case "sn":
          n = { ...n, ...this._getComboCheckFilter("text", i) };
          break;
        case "textarea":
          n.type = "textarea";
          let s = i && i.items ? i.items[0] : i && i.value;
          n.value = s ? BsyUtils.makeArray(s) : [];
          break;
        case "combocheck":
        case "checkboxgroup":
          n = { ...n, ...this._getComboCheckFilter("combocheck", i) };
          break;
        case "number":
          n.type = "number";
          if (n.method === "empty" || n.method === "not_empty") {
            n.value = [];
          } else {
            i &&
              (n.value = BsyUtils.isEmpty(i.value)
                ? [i.min, i.max]
                : [i.value]);
          }
          break;
        case "datetime":
          n.type = "datetime";
          let o = "yyyy-MM-dd";
          switch (e.type) {
            case "datetime_filter": {
              o = "yyyy-MM-dd HH:mm:ss";

              break;
            }
            case "datemonth_filter": {
              o = "yyyy-MM";
              break;
            }
            case "dateyear_filter": {
              o = "yyyy";
              break;
            }
            default:
          }
          // let o = "datetime_filter" === e.type ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
          // i && i.value ? n.value = [BsyUtils.date2Str(new Date(i.value), o)] : i && i.mode ? n.value = [i] : n.value = [i && i.min ? BsyUtils.date2Str(new Date(i.min), o) : null, i && i.max ? BsyUtils.date2Str(new Date(i.max), o) : null];
          n.valueMode = undefined;
          n.hasEmpty = undefined;
          if (i && i.value) {
            n.value = [typeof i.value === 'string' ? i.value : BsyUtils.date2Str(new Date(i.value), o)];
          } else {
            if (i && i.mode) {
              n.value = i;
            } else {
              n.value = [
                i && i.min ? typeof i.min === 'string' ? i.min : BsyUtils.date2Str(new Date(i.min), o) : null,
                i && i.max ? typeof i.max === 'string' ? i.max : BsyUtils.date2Str(new Date(i.max), o) : null,
              ];
            }
          }

          break;
        case "address":
        case "location":
          n.type = "address";
          n.value = i ? [i.province, i.city, i.district] : [];
          break;
        case "user":
        case "usergroup":
        case "dept":
        case "deptgroup":
        case "flowcreator":
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flow_chargers":
          n.type = "flow_chargers";
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flowstate":
        case "flowState":
          n.type = "flowstate";
          let e1 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e1) ? BsyUtils.makeArray(e1) : [];
          break;
        case "flowdecision":
          n.type = "flowdecision";
          let e2 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e2) ? BsyUtils.makeArray(e2) : [];
          break;
        case "backflowid":
          n.type = "backflowid";
          n.value = i;
          break;
        case "flownode":
          n.type = "flownode";
          n.value = i;
          break;
        case "upload":
        case "image":
          n.type = a.type;
          n.value = [];
          break;
        case "signature":
          n.type = "signature";
          n.value = [];
          break;
        case "assist_prostatus":
          n.type = "assist_prostatus";
          let e4 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e4) ? BsyUtils.makeArray(e4) : [];
          break;
        case "assist_flowid":
          n.type = "assist_flowid";
          let e3 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e3) ? BsyUtils.makeArray(e3) : [];
          break;
        default:
          break;
      }
    }
    this.filter[t] = { ...this.filter[t], ...n };
  };

  componentDidMount() {
    super.componentDidMount();
    this._initFilter();
  }

  setFilterSticky = (val) => {
    BsyUtils.Store.set("dataloadFilterSet", val);
  };

  getFilterSticky = () => {
    let res = BsyUtils.Store.get("dataloadFilterSet");
    return res;
  };

  onGetFilterPaneContext = (context) => {
    this.filterPaneContext = context;
  };

  getFilterConfig = () => {
    let that = this;
    const { filterSticky } = this.state;
    return {
      hasRelation: true,
      hasPin: false,
      hasSticky: true,
      hasHeader: true,
      filterSticky: filterSticky,
      filterTopSticky: false,
      hasfilterSticky: true,
      hasfilterTopSticky: false,
      mode: "dataload",
      rel: this.rel || "and",
      cond: BsyUtils.isObjectEmpty(this.cond) ? [] : this.cond,
      fields: that.options.selectFields.map((it) => {
        return {
          ...it,
          mode: "edit",
          triggers: ["datatable"],
        };
      }),
      onFilterClose: () => {
        this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        this.setState({
          filterSticky: false,
        });
      },
      onFilterSticky: () => {
        const { filterSticky } = this.state;
        this.setFilterSticky(!filterSticky);
        this.setState(
          {
            filterSticky: !filterSticky,
          },
          () => {
            if (!filterSticky) {
              this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
            }
          }
        );
      },
      onFilterTopSticky: () => {
        const { filterTopSticky } = this.state;
        if (!filterTopSticky) {
          this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        }
      },
      onSetFieldFilter: (val) => {
        this.rel = val.rel;
        this.cond = [...val.cond];
        this.rel = val.rel;

    
        this.filter = [...val.cond];
      
        this.componentContext.reload();
      },
      onFilter: (val, clearFilter) => {
        this.rel = val.rel;

        if (clearFilter) {
          this.filter = [];
        } else {
          this.filter = [...val.cond];
        }
        this.componentContext.reload();
      },
    };
  };

  loadData = (config, cb) => {
    let that = this;

    let data = {
      widgetAssistId: "datatable",
      widget: {
        fields: that.options.fields,
        forms: [that.options.forms],
        type: "data_table",
        formulas: [],
        filter: this.options.filter,
      },
      limit: 20,
      skip: 0,
      appId: that.options.appId,
      entryId: that.options.entryId,
      //   sort: that.options.defaultSort,
      rowOrder: {},
      top: {},
      hasCount: true,
      popupFormPath: [],
      designAppId: that.options.designAppId,
      designEntryId: that.options.designEntryId,
      designWidget: that.options.designWidget,
      ...config,
      search: this.search,
      filter: {
        rel: this.rel,
        cond: this.cond,
      },
    };
    // this.setState({ loading: true });
    React.axios(`/data/formdataload`, data).then((res) => {
      BsyUtils.showAjaxTip(res.data, () => {
        that.count = res.data.count;
        cb &&
          cb({
            data: {
              count: res.data.count,
              header: res.data.header,
              data: res.data.data,
              reftype: res.data.reftype,
              highlightFields: res.data.highlightFields,
            },
          });
      });
    });
  };

  tableHeader = () => {
    const { allowAdd, ignoreOptAuth } = this.options;
    const { filterSticky } = this.state;
    let that = this;
    return (
      <div className="data-header">
        <div className="left-pane">
          {ignoreOptAuth || allowAdd ? (
            <BsyButton
              text={React.language("create")}
              iconName={"icon-bsy-add"}
              height={30}
              click={() => {
                this.addData();
              }}
              mode={window.mode + " add "}
            />
          ) : (
            ""
          )}
        </div>
        <div className="right-pane">
          {filterSticky ? (
            ""
          ) : !that.options.selectFields ||
            that.options.selectFields.length === 0 ? (
            ""
          ) : (
            <BsyButton
              height={30}
              css={{
                color: that.options.selectFields.length ? "#0265ff" : "",
                display: filterSticky
                  ? "none"
                  : that.options.selectFields.length
                  ? ""
                  : "none",
              }}
              onMouseEnter={(event) => {
                window.FX.UI.showPopover({
                  position: "leftBottom",
                  anchor: window.$(event.target),
                  content: window
                    .$("<span/>")
                    .text(React.language("filter.condition")),
                  type: "dark",
                });
              }}
              onMouseLeave={() => {
                window.FX.UI.closePopover();
              }}
              tip={React.language("filter.condition")}
              type={"menu-right"}
              iconName={"icon-bsy-shaixuananniu"}
              click={(e) => {
                let config = that.getFilterConfig();
                BsyMsgBubble({
                  anchor: e.currentTarget,
                  customCls: "filter-bubble",
                  onGetContext: that.onGetFilterPaneContext,
                  contentHTML: () => {
                    return (
                      <BsyDataLoadFilterPane
                        {...config}
                      ></BsyDataLoadFilterPane>
                    );
                  },
                  text4Cancel: null,
                  text4Ok: null,
                  theme: this.props.theme,
                  minWidth: "auto",
                  width: 350,
                  contentPadding: 0,
                  edge: 200,
                  hAdjust: 72,
                  dockPosition: "right",
                  onClose: function () {
                    that.setState({});
                    return !1;
                  },
                });
              }}
              mode={window.mode}
            />
          )}

          <BsyButton
            height={30}
            onMouseEnter={(event) => {
              window.FX.UI.showPopover({
                position: "bottom",
                anchor: window.$(event.target),
                content: window.$("<span/>").text(React.language("refresh")),
                type: "dark",
              });
            }}
            onMouseLeave={(e) => {
              window.FX.UI.closePopover();
            }}
            tip={React.language("refresh")}
            type={"menu-right"}
            iconName={"icon-async"}
            click={() => {
              this.componentContext.reload();
            }}
            mode={window.mode}
          />
          {
            <BsySearchInput
              placeholder={React.language("search.data")}
              styleInput={{
                width: "200px",
              }}
              onSearch={(val) => {
                if (val) {
                  this.search.keywords = [val];
                } else {
                  this.search.keywords = [];
                }
                this.onSearchText();
                that.setSearchCach(this.search);
              }}
              type={window.mode}
              // iconName="icon-bsy-reportmenu-0"
              onExtElement={() => {
                return (
                  <>
                    <i onClick={this.onSearchFields} className="icon-bsy-xia" />
                  </>
                );
              }}
            ></BsySearchInput>
          }
        </div>
      </div>
    );
  };

  getSearchCacheKey = () => {
    const { entryId, appId, designWidget } = this.options;
    // const { appId, entryId, authGroupId } = this.state;
    return BsyUtils.Store.getKey("searchValueDataLoad", {
      appId: appId,
      entryId: entryId,
      ext: designWidget,
      authGroupId: "showdata",
    });
  };

  setSearchCach = (val) => {
    BsyUtils.Store.set(this.getSearchCacheKey(), val);
  };

  getSearchCach = () => {
    let res = BsyUtils.Store.get(this.getSearchCacheKey());
    if (res) {
      this.search = res;
    }
    this.setSearchCach(null);
  };

  onSearchFields = (event) => {
    this.showCombo(event.currentTarget);
  };

  showCombo = (currentTarget) => {
    const { fields } = this.options;
    this.fields = fields.filter((event) => {
      if (event.detailOnly === true) {
        return false;
      }
      if (event.dataOnly === true) {
        return false;
      }
      return event.name !== "label";
    });
    let that = this;
    // this.getSearchCach();
    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: () => {
        return (
          <SearchComboPane
            getContext={(e) => {
              that.searchContext = e;
            }}
            allCount={this.componentContext.state.allCount}
            formItems={this.fields}
            value={this.search}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: 210,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        that.searchFields = that.searchContext.fields;
        that.search = that.searchContext.getValue();
        if (that.search.keywords.length) {
          that.onSearchText();
        }
        that.setSearchCach(that.search);
        return !1;
      },
    });
  };

  getFieldConfig = () => {
    const { fields, entryId, appId, forms, isSubform, value, defaultSort } =
      this.options;

    let config = {
      url: "/data/filter",
      entryId: entryId,
      fields: fields,
      appId: appId,
      formId: entryId,
      forms: [forms],
      sort: defaultSort,
      checkStatus: isSubform ? "check" : "radio",
      width: "100%",
      height: "100%",
      widgetId: "datatableDataLoad",
      jsplatform: "React",
      autoHeight: "low",
      selectDataId: value?.id ? [value?.id] : [],
      onDataGet: (url, config, cb) => {
        this.loadData(
          {
            sort: config.sort,
            limit: config.limit,
            skip: config.skip,
          },
          cb
        );
      },
      selectSingleData: (data) => {
        // console.log('BsyFormLoadData ', data);
        this.props.onSelectData && this.props.onSelectData(data);
      },
    };
    return config;
  };

  getContext = (context) => {
    this.componentContext = context;
  };

  tableBody = () => {
    let config = this.getFieldConfig();

    return (
      <div className="data-body">
        <BsyDataTable
          {...config}
          skip={this.skip || 0}
          hasCount={false}
          getContext={this.getContext}
          level2Menu={true}
          key={this.componentKey}
          saveMultiPageData={true}
          isCheckAll={false}
          onDataFilter={this.onDataFilter}
          is_dock_form={false}
          getSearchData={() => {
            return this.search?.keywords?.length > 0;
          }}
        />
      </div>
    );
  };

  onSearchText = () => {
    let that = this;
    if (this.search.keywords && this.search.keywords.length) {
      if (this.componentContext.state.allCount > 10000) {
        if (this.search.isSearchAllFields === true) {
          this.search.isSearchAllFields = false;

          let n = 5;
          if (this.search.fields.indexOf("label") > -1) {
            n = 6;
          }

          if (this.search.fields.length == 0) {
            n = 6;
          }

          BsyUtils.forEach(this.options.fields, (a1, b1) => {
            if (that.search.fields.length >= n) {
              return false;
            }
            if (that.search.fields.indexOf(b1.name) === -1) {
              that.search.fields.push(b1.name);
            }
          });
        }
      }

      this.componentContext.reload({
        search: this.search,
        skip: 0,
      });
    } else {
      this.componentContext.reload({ search: null, skip: 0 });
    }
  };

  getValue = () => {
    return this.componentContext._getCheckData();
  };

  render() {
    const { cssName } = this.options;
    const { filterSticky } = this.state;
    let config = filterSticky ? this.getFilterConfig() : null;
    return (
      <div className={cssName + (filterSticky ? " filterSticky" : "")}>
        <div className="dataload-content">
          {this.tableHeader()}
          {this.tableBody()}
        </div>
        {filterSticky && (
          <BsyDataLoadFilterPane {...config}></BsyDataLoadFilterPane>
        )}
      </div>
    );
  }
}
